import { StrictMode } from 'react';
import ReactDOM from 'react-dom/client';
import App from './app/App';
import './index.css';
import 'katex/dist/katex.min.css';

console.log('APP_VERSION : ', APP_VERSION, ' / ', import.meta.env.MODE);

const rootElement = document.getElementById('root')!;
if (!rootElement.innerHTML) {
    const root = ReactDOM.createRoot(rootElement);
    root.render(
        // <StrictMode>
        <App />
        // </StrictMode>
    );
}
